import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useRecoilValue } from 'recoil';
import TooltipComponent from '../../TooltipComponent';
import { getIsColumnLast } from '../TableHeader/TableHeader';
import { INFO_FILTER, ITripsOverviewColumn } from '../interfaces';
import { INFO_KEY } from '../constants';
import {
  columnsAtom,
  isActiveAdvanceFilterAtom,
  isModalFormOpenedAtom,
} from '../TripsOverviewState';
import useAnalytics from '../../../hooks/useAnalytics';

interface IThInfoForRide {
  id: string;
}

export function ThInfoForRide(props: IThInfoForRide): JSX.Element {
  const columnsTable = useRecoilValue<ITripsOverviewColumn[]>(columnsAtom);
  const { formatMessage: f } = useIntl();
  const [, setIsModalFormOpened] = useRecoilState<string>(isModalFormOpenedAtom);
  const isActiveAdvanceFilter = useRecoilValue(isActiveAdvanceFilterAtom);
  const { trackEvent } = useAnalytics();

  const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    const { id } = event.currentTarget;

    setIsModalFormOpened(INFO_FILTER);
    trackEvent(['ride book', 'click', `Ride book open filter ${id}`]);
  };

  const showActiveFilter =
    isActiveAdvanceFilter.days ||
    isActiveAdvanceFilter.time ||
    isActiveAdvanceFilter.comment ||
    isActiveAdvanceFilter.ridebookPurpose ||
    isActiveAdvanceFilter.announcementAlarm ||
    isActiveAdvanceFilter.announcementWaypoint ||
    isActiveAdvanceFilter.announcementEvent ||
    isActiveAdvanceFilter.announcementBluecoin;
  return (
    <div
      className={`th-sticky b-table-actions ${showActiveFilter ? 'active' : ''}`}
      style={{ whiteSpace: 'nowrap', minWidth: '200px', flex: 1 }}
    >
      <TooltipComponent
        id={`ridebook-${props.id}`}
        overlay={
          <div style={{ color: '#fff', whiteSpace: 'pre-wrap', fontWeight: 'normal' }}>
            {`${f({
              id: 'tables.tripsOverview.column.info',
            })}: `}
            <strong>
              {`${f({
                id: 'tables.tripsOverview.header.tooltip.info',
              })}`}
            </strong>
          </div>
        }
        width="300px"
        style={{ top: '35px' }}
        positionLeft={getIsColumnLast(columnsTable, INFO_KEY)}
      >
        <div className="d-flex w-100">
          <div
            className="text-truncate"
            id={props.id}
            onClick={handleOnClick}
            data-cy={`filter-button-text-${props.id}`}
          >
            {f({ id: 'tables.tripsOverview.column.info' })}
          </div>
          <a
            href="#"
            className="filter cmd-icons cmd-icon-filter"
            id={props.id}
            onClick={handleOnClick}
            data-cy={`filter-button-${props.id}`}
          >
            {/* test */}
          </a>
        </div>
      </TooltipComponent>
    </div>
  );
}
